const ServiceData = [

  {
    serialNo: 0,
    id: 0,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/9a85c921_radha-rani-chhat.png",
    title: "Radha Rani Chhathi",
    Desc: "Join us at Yugal Kunj for the devotional celebration of Radha Rani Chhath. View the flyer for full details of the program.",
    Link: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/9a85c921_radha-rani-chhat.png",
    RegistrationLink: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/9a85c921_radha-rani-chhat.png",
    registerbtn: "View Flyer",
    target: "_blank",
    endDate: "2026-11-15",
  },

 

  {
    serialNo: 0,
    id: 0,
    imgsrc: "https://yugalkunj.org/images/Radhashtami.png",
    title: "Radhashtami Satsang & Celebrations",
    Desc: "Celebrate Radhashtami with satsang, devotional programs, flower poojan, special leela performances, and dinner prasad at Yugal Kunj.",
    Link: "/USA/Radhashtami",
    RegistrationLink: "/USA/Radhashtami",
    registerbtn: "Read More",
    target: "",
    endDate: "2026-09-19",
  },

  {
    serialNo: 1,
    id: 1,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/ad6af72c_janmashtami_Mahotsav.png",
    title: "Grand Janmashtami Celebrations",
    Desc: " Click here for more details...",
    Link: "/USA/Janmashtami",
    RegistrationLink: "/USA/Janmashtami",
    registerbtn: "Read More",
    target: "_blank",
    endDate: "2026-09-05",
  },

  {
    serialNo: 15,
    id: 15,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/97153409_11-Anniversary.png",
    title: "11th Anniversary Celebration - Musical Night",
    titleHtml: "11<sup>th</sup> Anniversary Celebration - Musical Night",
    Desc: "Bhajan Jamming & Bollywood Classic Melodies. Live Singing Performance. Saturday, Sept 5th, 7:00 – 9:00 pm.",
    Link: "/USA/Anniversary11th",
    RegistrationLink: "/USA/Anniversary11th",
    registerbtn: "View Details",
    target: "",
    endDate: "2026-09-05",
  },

  {
    serialNo: 2,
    id: 2,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/87797f71_onsite_partiking_fee.png",
    title: "Janmashtami Parking & Map Guide",
    Desc: "Parking details & venue map for Grand Janmashtami 2026. On-site parking $15. Free parking + shuttle at Primerica.",
    Link: "/USA/JanmashtamiParking",
    RegistrationLink: "/USA/JanmashtamiParking",
    registerbtn: "View Parking & Map",
    target: "",
    endDate: "2026-09-05",
  },

  {
    serialNo: 3,
    id: 3,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/8f5b150a_Gurukul-2026-27-v3.png",
    title: "Gurukul Classes",
    Desc: " Click here for more details...",
    Link: "https://portalyk.yugalkunj.org/",
    RegistrationLink: "https://portalyk.yugalkunj.org/",
    registerbtn: "Register Now",
    target: "_blank",
    endDate: "2027-05-10",
  },



  {
    serialNo: 3,
    id: 3,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/fgm/gallery/image/1/0f3995c8_FGMFlyer.png",
    title: "Featured Community Program",
    Desc: "Now enrolling toddlers, preschool, and kindergarten students in a safe, nurturing Montessori environment ...",
    Link: "https://flowerygrovemontessori.org/",
    RegistrationLink: "https://flowerygrovemontessori.org/",
    registerbtn: "Register Now",
    target: "_blank",
    endDate: "2027-04-26",
  },
  


 

  // {
  //   serialNo: 6,
  //   id: 6,
  //   imgsrc: "https://stssevastorage.blob.core.windows.net/media/hyc/events/image/1/a589b86f_Fall_Festival.jpeg",
  //   title: "Fall Festival 2026",
  //   Desc: "Join us for a night of joy, community & fun for all ages! Games, face painting, bouncy house, raffle prizes & more!",
  //   Link: "/USA/FallFestival",
  //   RegistrationLink: "/USA/FallFestival",
  //   registerbtn: "Read More",
  //   target: "",
  //   endDate: "2026-09-25",
  // },

   {
    serialNo: 7,
    id: 7,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/828324af_dushehra-2026.jpeg",
    title: "Dussehra Special Navadha Bhakti",
    Desc: "A Special Discourse Series with Gopeshwari Didi Ji. ",
    Link: "/USA/upcomingevents",
    RegistrationLink: "/USA/upcomingevents",
    registerbtn: "Upcoming Events",
    target: "_blank",
    endDate: "2026-10-21",
  },

  {
    serialNo: 8,
    id: 8,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/5eb32162_Financial-litracy.jpeg",
    title: "Beyond Books: Financial Literacy for Youth",
    Desc: "Learn smart money habits! Save wisely, spend smartly, set goals. Ages 7-18. Friday, Oct 30th, 7:30-8:30 PM.",
    Link: "/USA/upcomingevents",
    RegistrationLink: "https://schools.procareconnect.com/form/48738787-12dc-44d7-8012-b066c872ba67",
    registerbtn: "Register Now",
    target: "_blank",
    endDate: "2026-10-30",
  },

  {
    serialNo: 10,
    id: 10,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/9913aac1_classical_musice-20-27.png",
    title: "Carnatic Classical Music ",
    Desc: "Learn the beauty of Carnatic Classical Music with expert guidance.",
    Link: "/USA/upcomingevents",
    RegistrationLink: "https://portalyk.yugalkunj.org/",
    registerbtn: "Register Now",
    target: "_blank",
    endDate: "2026-11-23",
  },

  {
    serialNo: 11,
    id: 11,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/11b48fbf_bharatnatyam_2026-27.png",
    title: "Bharatnatyam Dance classes",
    Desc: "Discover the grace, tradition, and beauty of Bharatanatyam. ...",
    Link: "/USA/upcomingevents",
    RegistrationLink: "https://portalyk.yugalkunj.org/",
    registerbtn: "Register Now",
    target: "_blank",
    endDate: "2026-11-23",
  },

  {
    serialNo: 12,
    id: 12,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/41606786_dholak_class_2026.png",
    title: "Dholak Classes ",
    Desc: "Learn traditional Dholak rhythms and bring music to life. ...",
    Link: "/USA/upcomingevents",
    RegistrationLink: "https://portalyk.yugalkunj.org/",
    registerbtn: "Register Now",
    target: "_blank",
    endDate: "2026-11-23",
  },



  {
    serialNo: 13,
    id: 13,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/4d5d3f28_harmonai_vocal_2026-27.png",
    title: "Harmonium & Vocal Classes",
    Desc: "Learn singing and harmonium while exploring the beauty of Indian music. ...",
    Link: "/USA/upcomingevents",
    RegistrationLink: "https://portalyk.yugalkunj.org/",
    registerbtn: "Register Now",
    target: "_blank",
    endDate: "2026-11-23",
  },

  {
    serialNo: 14,
    id: 14,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/38277e05_YugalKunjexpansion.jpg",
    title: "Yugal Kunj Expansion",
    Desc: "Click here for more details on Kunj expansion",
    Link: "#",
    RegistrationLink: "#",
    registerbtn: "Read More",
    target: "",
    endDate: "2027-05-30",
  },
  {
    serialNo: 15,
    id: 15,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/da96ef6a_under-construction-yk.jpg",
    title: "Construction Update",
    Desc: "Click here for more details",
    Link: "#",
    RegistrationLink: "#",
    registerbtn: "Read More",
    target: "",
    endDate: "2027-05-30",
  },
  {
    serialNo: 16,
    id: 16,
    imgsrc: "https://stssevastorage.blob.core.windows.net/ykwebsite/resource/cause-image-3.jpg",
    title: "Order Prasad",
    Desc: "Sacred vegetarian Prasad offered to devotees",
    Link: "https://portalyk.yugalkunj.org/#/tiffin/menu",
    RegistrationLink: "https://portalyk.yugalkunj.org/#/tiffin/menu",
    registerbtn: "Order",
    target: "",
    endDate: "2030-05-30",
  },
  {
    serialNo: 17,
    id: 17,
    imgsrc: "https://stssevastorage.blob.core.windows.net/ykwebsite/flyer/OrganicGarden.jpeg",
    title: "Join Our Organic Gardening Seva",
    Desc: "Click here for more details on Organic Gardening Seva",
    Link: "/USA/upcomingevents",
    RegistrationLink: "/USA/upcomingevents",
    registerbtn: "Register",
    target: "",
    endDate: "2030-08-17",
  },
  {
    serialNo: 18,
    id: 18,
    imgsrc: "https://stssevastorage.blob.core.windows.net/ykwebsite/resource/featured-image-6.jpg",
    title: "Event Rentals",
    Desc: "Click here for more details on Event Rentals",
    Link: "/USA/eventrentals",
    RegistrationLink: "https://ykrentals.yugalkunj.org/",
    registerbtn: "Register",
    target: "_",
    endDate: "2035-05-30",
  },
  {
    serialNo: 19,
    id: 19,
    imgsrc: "https://stssevastorage.blob.core.windows.net/ykwebsite/resource/Geeta-Beginner.png",
    title: "Classes",
    Desc: "Gurukul classes offered by Radha Madhav Society",
    Link: "https://portalyk.yugalkunj.org/#/class/center",
    RegistrationLink: "https://portalyk.yugalkunj.org/#/class/center",
    registerbtn: "Register",
    target: "",
    endDate: "2035-05-30",
  },


  {
    serialNo: 20,
    id: 20,
    imgsrc: "https://stssevastorage.blob.core.windows.net/ykwebsite/ykseva.png",
    title: "Cooking Seva",
    Desc: "Click here to register for Cooking Seva",
    Link: "https://ykportal.yugalkunj.org/Home/CountrySelect",
    RegistrationLink: "https://ykportal.yugalkunj.org/Home/CountrySelect",
    registerbtn: "Register",
    target: "",
    endDate: "2035-05-30",
  },
  {
    serialNo: 21,
    id: 21,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/3933f205_donation.png",
    title: "Donate Grocery",
    Desc: "Please make Donate Grocery of essential items.",
    Link: "/USA/FoodDonation",
    RegistrationLink: "/USA/FoodDonation",
    registerbtn: "Donation",
    target: "_blank",
    endDate: "2050-08-02",
  }
];

export default ServiceData;
